import { createContext } from "react";

export const IvaContext = createContext()
export const IvaFormContext = createContext()
export const IvaReportContext = createContext()